import React, { useEffect } from 'react';
import { OptionGroup } from '../../../models/select';
import { useSingleton } from '@bydesign-ui/hooks';
import { OptionGroupContext } from '../context/optionGroup';
import { useOptionGroup } from '../hooks/useOptionGroup';
import { useSelect } from '../hooks/useSelect';
export function RcOptionGroup(props) {
  var children = props.children,
      title = props.title,
      groupId = props.groupId;
  var select = useSelect();
  var optionGroup = useOptionGroup();
  var group = useSingleton(function () {
    return new OptionGroup(select, groupId, optionGroup || undefined);
  });
  useEffect(function () {
    group.updateOptionGroupOptions({
      title: title
    });
  });
  useEffect(function () {
    return function () {
      group.dispose();
    };
  }, []);
  return React.createElement(OptionGroupContext.Provider, {
    value: group
  }, children);
}